const appSyncConfig = {
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_AWS_GRAPHQL_URL,
  aws_appsync_region: process.env.REACT_APP_AWS_REGION,
  aws_appsync_apiKey: process.env.REACT_APP_AWS_API_KEY,
  aws_appsync_authenticationType: 'API_KEY',
}

export default appSyncConfig
